import Text from "@ingka/text";
import { AssetDto } from "generated";

type Props = {
  assets: AssetDto[];
};
export const AssetNameOverview = ({ assets }: Props) => (
  <div className="pb-space100">
    <Text tagName="h3" headingSize="s" className="my-space100">
      Edited asset name(s)
    </Text>
    <div className="flex h-space300 border-b ps-space150">
      <Text tagName="span" className="w-1/2 content-center">
        Initial name
      </Text>
      <Text tagName="span" className="w-1/2 content-center">
        Ingka DAM name
      </Text>
    </div>
    <div className="h-full overflow-y-auto">
      {assets
        .filter((asset) => asset.state === "DONE")
        .map((asset) => (
          <div key={asset.id} className="flex h-space400 border-b ps-space150">
            <Text
              tagName="span"
              className="w-1/2 content-center truncate pr-space100 text-black"
              title={asset.filename}
            >
              {asset.filename}
            </Text>
            <Text
              tagName="span"
              className="w-1/2 content-center truncate text-black"
              title={asset.name}
            >
              {asset.name}
            </Text>
          </div>
        ))}
    </div>
  </div>
);
